import actionTypes from '../constants/action-types';

const layoutState = {
  tabs: null,
  accountManagerInfo: null,
  news: null,
  showMenu: false,
  uiBlocked: false,
};

export const layoutReducer = (state = layoutState, payload) => {
  switch (payload.type) {
    case actionTypes.SET_TABS:
      return { ...state, tabs: payload.data };
    case actionTypes.HANDLE_GET_ACCOUNT_MANAGER_INFO:
      return { ...state, accountManagerInfo: payload.data };
    case actionTypes.HANDLE_GET_NEWS:
      return { ...state, news: payload.data };
    case actionTypes.TOGGLE_MENU:
      return { ...state, showMenu: payload.data };
    case actionTypes.HANDLE_BLOCK_UNBLOCK_UI:
      return { ...state, uiBlocked: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/layout/reducers/layout-reducer.js